module.exports = __webpack_public_path__ + "static/media/subBanner2.e8a53b1b.png";